module.exports = __webpack_public_path__ + "img/Skirt-Back-B5-Da-Fc-Ga-Ha-Ia-Gc.4cf65740.png";